import * as React from "react";
import { classNames } from "../../utils";
const PageTile = ({
  title,
  description,
  image,
  link_image,
  url,
  urltext,
  style,
  classes,
  date_text,
  date_number,
}) => {
  // add slash at the beginning of
  const addSlash = (url) => {
    return url.charAt(0) !== "/" ? "/" + url : url;
  };
  return (
    <div
      className={classNames("flex flex-col page-item", classes)}
      style={{ ...style }}
    >
      {image && link_image && (
        <a href={addSlash(url)} className="page-item-image-link">
          <img src={image.href} alt={`Image of ${title}`} className="w-full" />
        </a>
      )}
      {image && !link_image && (
        <img src={image.href} alt={`Image of ${title}`} className="w-full" />
      )}
      {date_text && <span className="item-date">{date_text}</span>}
      {title && <h3 className="item-title text-left">{title}</h3>}
      {date_number && <span className="item-date">{date_number}</span>}
      {description && (
        <span className="item-description text-center">{description}</span>
      )}
      {url && urltext && (
        <span>
          <a href={addSlash(url)} className="item-link" aria-label={`${urltext} about ${title}`}>
            {urltext}
          </a>
        </span>
      )}
    </div>
  );
};

export default PageTile;
